import { COURSE_FETCH_ENDED } from '../../types';
export const setCourseData = data => ({
  data,
  type: COURSE_FETCH_ENDED
});